import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Counter from "../Counter/Counter.js";
import './Header.css';/* empty css            */
const HeaderCounter = ({ count, prefix, postfix }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-header-counter"), children: /* @__PURE__ */ jsx(Counter, { count, prefix, postfix }) });
};
export {
  HeaderCounter as default
};
//# sourceMappingURL=HeaderCounter.js.map
